import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import {createStore} from "redux";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import './index.css';
import {Directory, ProjectEdit, ProjectMap} from "./Screens";
import reportWebVitals from './reportWebVitals';
import reducer from "./Reducers";

import './i18n/i18n';
import PartnerContact from "./Screens/PartnerContact";
import CompanyProfile from "./Screens/ProfileEdit/CompanyProfile";
import UserDashboardProfile from "./Components/Dashboard/UserDashboardProfile";
import CompanyDashboardProfile from "./Components/Dashboard/CompanyDashboardProfile";

const store = createStore(reducer);

const App = () => (
    <Switch>
        <Route path="/projects/create/:projectId" component={ProjectEdit}/>
        <Route path="/fr-ca/projects/create/:projectId" component={ProjectEdit}/>
        <Route path="/en-ca/projects/create/:projectId" component={ProjectEdit}/>
        <Route path="/projects" component={ProjectMap}/>
        <Route path="/directory" component={Directory}/>
        <Route path="/account/project/:project_id/management" component={ProjectEdit}/>
        <Route path="/account/company/:project_id/update" component={CompanyProfile}/>
        <Route path="/contact-suppliers" component={PartnerContact}/>
        <Route path="/building-material-contact" component={PartnerContact}/>
        <Route path="/fr-ca/projects/" component={ProjectMap}/>
        <Route path="/fr-ca/directory/" component={Directory}/>
        <Route path="/fr-ca/account/project/:project_id/management" component={ProjectEdit}/>
        <Route path="/fr-ca/account/company/:project_id/update" component={CompanyProfile}/>
        <Route path="/en-ca/projects/" component={ProjectMap}/>
        <Route path="/en-ca/directory/" component={Directory}/>
        <Route path="/en-ca/account/project/:project_id/management" component={ProjectEdit}/>
        <Route path="/en-ca/account/company/:project_id/update" component={CompanyProfile}/>
    </Switch>
);

const rootDom = document.getElementById('root');
const profileDashboardDom = document.getElementById('rootDashboardProfileStats');
const companyDashboardDom = document.getElementById('rootDashboardCompanyStats');
if (rootDom) {
    console.log('App', App);
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Router>
                    <App/>
                </Router>
            </Provider>
        </React.StrictMode>,
        document.getElementById('root')
    );
}
if (profileDashboardDom) {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <UserDashboardProfile/>
            </Provider>
        </React.StrictMode>,
        document.getElementById('rootDashboardProfileStats')
    );
}

if (companyDashboardDom) {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <CompanyDashboardProfile/>
            </Provider>
        </React.StrictMode>,
        document.getElementById('rootDashboardCompanyStats')
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
